import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Landing from "./pages/Landing";
import Why from "./pages/Why";
import Vision from "./pages/Vision";
import ValuesProfile from "./pages/ValuesProfile";
import Reflection from "./pages/Reflection";
import Dashboard from "./pages/Dashboard";
import Circle from "./pages/Circle";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import AuthCallback from "./pages/AuthCallback";
import Account from "./pages/Account";
import MagicLinkRequest from "./pages/MagicLinkRequest";
import MagicLinkVerify from "./pages/MagicLinkVerify";
import Admin from "./pages/Admin";

// Router component that checks for auth callback
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (auth callback)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/why" element={<Why />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/values-profile" element={<ValuesProfile />} />
      <Route path="/reflection" element={<Reflection />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/circle" element={<Circle />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/email" element={<MagicLinkRequest />} />
      <Route path="/auth/magic" element={<MagicLinkVerify />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
